import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from "@angular/core";
import {
  trigger,
  state,
  style,
  animate,
  transition
} from "@angular/animations";
import {
  HttpClient,
  HttpResponse,
  HttpRequest,
  HttpEventType,
  HttpErrorResponse,
  HttpHeaders
} from "@angular/common/http";
import { of } from "rxjs";
import { catchError, last, map, tap } from "rxjs/operators";
import { FileUploadModel } from './file-upload.model';
import { SystemFile } from "src/app/shared/models/file.model";
import { SystemLog } from "src/app/shared/models/sysLog.model";
import { Permission } from "src/app/shared/models/permission.model";
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { HotToastService } from "@ngneat/hot-toast";
import { BsModalService } from "ngx-bootstrap";
import { DemoService } from "src/app/demo.service";
import { FileUploaderService } from "src/app/services/file-uploader-service";
import { GlobalFunctionsService } from "src/app/services/global-functions.service";
import { MysqlService } from "src/app/services/mysql.service";


import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';


@Component({
  selector: 'app-job-file-upload-widget2',
  templateUrl: './job-file-upload-widget2.component.html',
  styleUrls: ['./job-file-upload-widget2.component.scss'],
  animations: [
    trigger("fadeInOut", [
      state("in", style({ opacity: 100 })),
      transition("* => void", [animate(300, style({ opacity: 0 }))])
    ])
  ]
})
export class JobFileUploadWidget2Component implements OnInit {


  // setup as observable?
  @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data?= 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id?= '5'; // default to agent just in case
  @Input() item_brand_type_id?;
  @Input() show_buttons?= 'no'; // yes | no
  @Input() widget_title?= 'File Uploads';
  @Input() widget_size?; // side | abstract | full | attempt

  @Input() subject_id?: any;
  @Input() file_number?: any; // subject file number
  @Input() subject_number?: any; // subject file number
  @Input() brand_type_id?: number; // subject file number
  @Input() reference_number?: any; // subject file number
  
  @Input() subject_service_id?: any; // subject file number
  @Input() service_file_array?: any; // subject file number

  job_id: any;
  model: any; // File upload permissions model.
  job: any;
  file_model: SystemFile;
  sendableFormData: FormData; // populated via ngfFormData directive

  //  :: file uploader Variables
  // map the result through the model
  // create_file: SystemFile;
  create_file: SystemFile;
  //create_files: File[];
  create_sys_log: SystemLog;
  permission_model: Permission;


  allAgentRecipients: any[];


 /** Link text */
 @Input() text = "Upload";
 /** Name used in form which will be sent in HTTP request. */
 @Input() param = "file";
 /** Target URL for file uploading. */
//  @Input() target = "https://file.io";
@Input() target;
 /** File extension that accepted, same as 'accept' of <input type="file" />. By the default, it's set to 'image/*'. */
 @Input() accept = "image/*";
 /** Allow you to add handler after its completion. Bubble up response text from remote. */
 @Output() complete = new EventEmitter<string>();

//  public files: Array<FileUploadModel> = [];
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  current_base_route: string;
  brand_types: Object;
  brands: any;
  user_levels: Object;
  created_file_name: any;
  file_edit_level: number;
  file_created_response: any;
  returned_created_file_id: any;
  system_log_created_response: Object;
  url: string;


  constructor(public _http: HttpClient,
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
    ) {
      

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));
  
if(this.widget_size == ''){
  this.widget_size = 'full';
}

    }

  ngOnInit(): void {
    
      // item_id is the sent job_id
      this.url = this.gfunc.php_apiURL_SSL + '/uploadFiles.php?job_id=' + this.item_id;
      this.target = this.url;

  }



  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
      data => { 
        this.brand_types = data; 
      
      },
      err => console.error(err),
      // () => console.log('done loading candidate for update')
    );
  }
  getBrands() {
    this._demoService.getBrands().subscribe(
      data2 => {
        this.brands = data2;
        // console.log(data2);
      },
      err => console.error(err),
      () => console.log('done loading User Brands')
    );
  }
  getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
      data2 => {
        this.user_levels = data2;
        console.log(data2);
      },
      err => console.error(err),
      //  () =>  console.log('done loading User Levels')
    );
  }



        // onDrop(files: FileList) {
        //   for (let index = 0; index < files.length; index++) {
        //     const file = files[index];
        //     this.files.push({
        //       data: file,
        //       state: "in",
        //       inProgress: false,
        //       progress: 0,
        //       canRetry: false,
        //       canCancel: true
        //     });
        //     this.uploadFiles();
        //   }
        // }

        // onClick() {
        //   const fileUpload = document.getElementById(
        //     "fileUpload"
        //   ) as HTMLInputElement;
        //   fileUpload.onchange = () => {
        //     for (let index = 0; index < fileUpload.files.length; index++) {
        //       const file = fileUpload.files[index];
        //       this.files.push({
        //         data: file,
        //         state: "in",
        //         inProgress: false,
        //         progress: 0,
        //         canRetry: false,
        //         canCancel: true
        //       });
        //     }
        //     this.uploadFiles();

            
        //   };
        //   fileUpload.click();
        // }

        // cancelFile(file: FileUploadModel) {
        //   file.sub.unsubscribe();
        //   this.removeFileFromArray(file);
        // }

        // retryFile(file: FileUploadModel) {
        //   this.uploadFile(file);
        //   file.canRetry = false;
        // }

        // private uploadFile(file: FileUploadModel) {
        //   const fd = new FormData();
        //   fd.append(this.param, file.data );

        //   const req = new HttpRequest("POST", this.target, fd, {
        //     reportProgress: true
        //   });

        //   file.inProgress = true;
        //   file.sub = this._http
        //     .request(req)
        //     .pipe(
        //       map(event => {
        //         switch (event.type) {
        //           case HttpEventType.UploadProgress:
        //             file.progress = Math.round((event.loaded * 100) / event.total);
        //             break;
        //           case HttpEventType.Response:
        //             return event;
        //         }
        //       }),
        //       tap(message => {}),
        //       last(),
        //       catchError((error: HttpErrorResponse) => {
        //         file.inProgress = false;
        //         file.canRetry = true;
        //         return of(`${file.data.name} upload failed.`);
        //       })
        //     )
        //     .subscribe((event: any) => {
        //       if (typeof event === "object") {
        //         this.removeFileFromArray(file);
        //         this.complete.emit(event.body);
        //       }
        //     });
        // }

        // private uploadFiles() {
        //   const fileUpload = document.getElementById(
        //     "fileUpload"
        //   ) as HTMLInputElement;
        //   fileUpload.value = "";

        //   this.files.forEach(file => {
        //     this.uploadFile(file);
        //   });
        // }

        // private removeFileFromArray(file: FileUploadModel) {
        //   const index = this.files.indexOf(file);
        //   if (index > -1) {
        //     this.files.splice(index, 1);
        //   }
        // }

  setFilePermissions(model) {
    // need to set file submission data to set corret file/access upon upload.
  };






  // New file and document system Permisions on Job file Uploads
  createJobFileData(files) {

    // Loop through array
    for (let entry of files) {
      // for (let entry of this.files) {
      console.log(entry); // 1, "string", false
      this.created_file_name = entry.fileEntry.name;

      this.file_edit_level = 3;

      // agemt security: if agent creating then remove other agents from array first
      if(this.gfunc.sessionUserLevel == 5) {
      this.RemoveElementOthersFromAllAgentRecipients(this.gfunc.sessionBrandId); // adds the logged in agents
      }
      //need to loop through all files and do a seperate insert for each.
      // this.created_file_name = fileupload_data;

      const file_server_location = this.gfunc.file_server_location_JobAssets + '/' + this.job_id;
      // need to make this transportable.
      const file_url = this.gfunc.baseUploadURL_JobAssets + '/' + this.job_id + '.' + this.created_file_name;
      const file_folder = this.gfunc.file_folder_jobAssets + '/' + this.job_id;

      // finds last period .  and removes all before. ie extension of a file.
      const ext = this.created_file_name.substr(this.created_file_name.lastIndexOf('.') + 1);

      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      this.create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: ext,
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'uploaded', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via a client upload',
        file_job_id: this.job_id,
        file_subject_id: this.subject_id,
        file_subject_number: this.subject_number,
        created_by: this.gfunc.sessionUserId,
        created_date: this.gfunc.today,
        created_level: this.gfunc.sessionUserLevel,
        file_brand_id: this.gfunc.sessionBrandId, //?? should this be the subject client report brand id???? upon upload
        file_access_level: 9, // ? who can access this file and below (client 9 or agent 5 staff 4 manager 3 admin 2 master 1
        is_active: '1',
        file_password: '',
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: null,
        updated_date: null,
        prev_file_id: null,    // if updating
        // brand_type_id: this.permission_model.brand_type_id,  // if an agent or a client file
        brand_type_id: 1,  // if an agent or a client file
        subject_template_doc_id: null,
        subject_com_type_id: null,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        name: entry.name,
        size: entry.size,
        type: entry.type,
        file_number: this.file_number,
        reference_number: this.reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        agent_access_array: null, // collect current agent ids
        report_access_array: null, // collect client
        invoice_access_array: null, // collect client
        user_access_array: null, // of selected associated users.
        // Give Access to Users associated with this job, agents, client invoice user, client report user
        assigned_to_agents: JSON.stringify(this.allAgentRecipients),
        is_encrypted: 0
      //  subject_service_id: model.subject_service_id,
        //  Need to fix message sysetm to send to real invoice and primary user for company, and
        //  TO DO :  create a send to company listed contact email, as well as fix above,
        //  This means that a user that is a company invoice user, or a primary user (First user created with the account)
        /* 
              agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
              report_access_array: JSON.stringify(this.brand_data), // collect client
              invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
              user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users. */
      } as SystemFile;  /// Rixes the deserialisation errors!!! as File (model)
      // console.log( (JSON.stringify(this.assignedBrandList)) );



      this.createFile(this.create_file);  /// run this inside the function to get the insert file ID for Note.


    } // end loop entry of uploaded files

  }



  createFile(model) {
    this._demoService.createFile(model).subscribe(
      data => {
        this.file_created_response = data;
        const res = data;
        // need to get the returned ID to send to log create action
        // this.returned_created_file_id = this.file_created_response.last_insert_id;
        this.returned_created_file_id = this.file_created_response.last_insert_id;

        let notice_model = [];
        let inserted_file_id = this.returned_created_file_id;
        console.log('InsideFunction Loop: file_ID: ' + this.returned_created_file_id);

        // Now insert the note
        // const brand_type_id = this.permission_model.brand_type_id;
        const brand_type_id = 1;  // if an agent or a client file

        const log_action = 'uploaded';
        const log_name = 'Client Uploaded a job file: ' + this.job_id + ' - ' + this.created_file_name + '';
        this.create_sys_log = {
          log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
          log_action: log_action, // automated / updated / created / uploaded / link_created / sent
          created_by: this.gfunc.sessionUserId,
          created_date: this.gfunc.today,
          subject_id: this.subject_id,
          job_id: this.job_id,
          job_reference_number: this.job_id,
          file_number: this.file_number,
          reference_number: this.reference_number,
          subject_number: this.subject_number,
          // subject_number: model.file_subject_number,
          log_type_id: 1, // see datatable system_log_types
          created_level: this.gfunc.sessionUserLevel,
          brand_type_id: brand_type_id,
          subject_com_type_id: null,
          subject_template_doc_id: null,
          log_name: log_name + ' - ' + this.created_file_name,
          file_id: inserted_file_id,
          last_insert_id: this.returned_created_file_id,
          file_name: this.created_file_name
        } as SystemLog;

        // Set a delay function in javascript. per second to make sure we have the value.

        // this.createSystemLog(this.create_sys_log);
        notice_model = {
          ...model,
          ...this.create_sys_log,
        };

        if(this.subject_id >= 1){
          // subject file
        this.gfunc.insertLog_UploadSubjectFile(notice_model);
        }
        if(this.subject_id == undefined) {
          // job file
          this.gfunc.insertLog_UploadJobFile(notice_model);
          }

        console.log(this.returned_created_file_id);
        this.toastr.success('File uploaded successfully and permissions have been set.');
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  createSystemLog(model) {
    this._demoService.createSystemLog(model).subscribe(
      data => { this.system_log_created_response = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  // :: end file upload database and Insert Log

  

RemoveElementOthersFromAllAgentRecipients(key: number) {
  // test! -- load again an then filter and create the array again.
  // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.

  // delay load slightly so I can refresh the allRecpientList first.
  setTimeout(function() {   
}, 2000);
    console.log("Ready to clean array!")

  let array = this.allAgentRecipients;
  // removes all not matching
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
    this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_brand_id !== key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
  // console.log('allAgentRecipients after Removal Others: ', JSON.stringify(this.allAgentRecipients));

// ::@https://stackoverflow.com/questions/5310304/remove-json-element
// let json = this.allRecipients
// let id_key = "recipient_brand_id";
// delete json[id_key]; // Removes json.foo from the dictionary.



};










public files: NgxFileDropEntry[] = [];

public dropped(files: NgxFileDropEntry[]) {
  this.files = files;
 
  for (const droppedFile of files) {

    // Is it a file?
    if (droppedFile.fileEntry.isFile) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {

        // Here you can access the real file
        console.log(droppedFile.relativePath, file);


  // apends the value to the form.
  const formData = new FormData()
  formData.append('job_id', this.item_id);
  formData.append('file[]', file, droppedFile.relativePath)

  // this.sendableFormData.append('subject_id', this.subject_id);
        //  const req = new HttpRequest<FormData>(
        //    'POST',
        //    this.url,
        //    formData, {
        //    reportProgress: true, responseType: 'text'
        //  },
        //  );

      // Headers
      const headers = new HttpHeaders({
        'security-token': 'mytokenMEOW'
      })

   this.http.post(this.url, formData, { headers: headers, responseType: 'text' })
   .subscribe(data => {
     // Sanitized logo returned from backend
     console.log(data);
    
     this.toastr.success('file uploaded');
   })




        /**
        // You could upload it like this:
        const formData = new FormData()
        formData.append('logo', file, relativePath)

        // Headers
        const headers = new HttpHeaders({
          'security-token': 'mytoken'
        })

        this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
        .subscribe(data => {
          // Sanitized logo returned from backend
        })
        **/

      });
    } else {
      // It was a directory (empty directories are added, otherwise only files)
      const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      console.log(droppedFile.relativePath, fileEntry);
    }
  }

// now upload
this.createJobFileData(files);

}

public fileOver(event){
  console.log(event);
}

public fileLeave(event){
  console.log(event);
}









}
